import FamilyGenderMixedIconPath from "@ingka/ssr-icon/paths/family-gender-mixed";

export default FamilyGenderMixedIconPath;
